var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.result)?_c('IconBtn',{attrs:{"icon":"mdi-download","title":"PDF"},on:{"click":function($event){return _vm.generatePDF()}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }